import axiosInstance from "../axiosInstanceSetup";
const BASE_URL = process.env.REACT_APP_API_URL;
const accessManagementService = {
  // Example function to fetch data
  getAllUser: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/users/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  // /user/access/
  getAllUserAccess: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/user/access/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  removeUser: async (userId) => {
    console.log(userId);

    try {
      const response = await axiosInstance.delete(`${BASE_URL}/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  getAllRoles: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/roles`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  getProducts: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/access-management/products`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  changeUserRole: async (reqBody) => {
    console.log(reqBody);
    // /update-user-role/
    try {
      const response = await axiosInstance.put(
        `${BASE_URL}/user_bulk_update`,
        reqBody
      );
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  changeUserRolePermission: async (reqBody) => {
    try {
      const response = await axiosInstance.put(
        `${BASE_URL}/update-user-permission/`,
        reqBody
      );
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  getDomainsAndSubDomains: async (reqBody) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/domains-subdomains/`
      );
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  getCountryAndRegion: async (reqBody) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/regions-countries-list/`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  getLoggedInUserDetails: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/user/details`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  createNewUser: async (reqBody) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}/user/`, reqBody);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  updateUser: async (reqBody) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}/user/${reqBody.user_id}`, reqBody);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
  getAllRolesPermission: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/user-permissions/`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
};

export default accessManagementService;
